import { render, staticRenderFns } from "./info-circle-alt.vue?vue&type=template&id=170d4a6a&scoped=true&"
import script from "./info-circle-alt.vue?vue&type=script&lang=js&"
export * from "./info-circle-alt.vue?vue&type=script&lang=js&"
import style0 from "./info-circle-alt.vue?vue&type=style&index=0&id=170d4a6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170d4a6a",
  null
  
)

export default component.exports